import { Action, ApiState } from '../../../../types';
import { callService, serviceReducer } from '../../../../shared/hooks/serviceReducer';
import { OperationMembersFilter, OperationMembersHistory } from '../../../../services/types/Member';

export type HistoryMemberAction =
  | Action<OperationMembersHistory, OperationMembersFilter>
  | { type: 'PAGE'; value: number }
  | { type: 'PAGE_SIZE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<OperationMembersHistory, OperationMembersFilter>,
  action: HistoryMemberAction
): ApiState<OperationMembersHistory, OperationMembersFilter> => {
  switch (action.type) {
    case 'PAGE':
      return callService(state, { ...state.filter, pageNumber: action.value });
    case 'PAGE_SIZE':
      return callService(state, { ...state.filter, pageSize: action.value });
    case 'ORDER':
      return callService(state, {
        ...state.filter,
        pageNumber: 1,
        sortField: action.column,
        sortDescending: action.descending,
      });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
